import { FIELD_REP_ELITE_DESIGNATION_EDIT } from "typeConstants/rights";

export const COMMERCIAL_INT = "COMMERCIAL_INT";
export const FARM = "FARM";
export const WIND = "WIND";
export const LENDER = "LENDER";
export const HIGH_VALUE = "HIGH_VALUE";
export const COMMERCIAL_EXT = "COMMERCIAL_EXT";
export const ELITE_HIGH_VALUE = "ELITE_HIGH_VALUE";
export const LENDER_COMMERCIAL = "LENDER_COMMERCIAL";
export const BUILDERS_RISK = "BUILDERS_RISK";

export const designationLabelByCode = {
  COMMERCIAL_INT: "Commercial Interior",
  FARM: "Farm",
  WIND: "Wind",
  LENDER: "Lender",
  HIGH_VALUE: "High Value",
  COMMERCIAL_EXT: "Commercial Exterior",
  ELITE_HIGH_VALUE: "Elite High Value",
  LENDER_COMMERCIAL: "Commercial Lender",
  BUILDERS_RISK: "Builders Risk",
};

export const designationEditRights = {
  ELITE_HIGH_VALUE: FIELD_REP_ELITE_DESIGNATION_EDIT,
};

export const canEditDesignationCode = (code, rights) => {
  if (Object.keys(designationEditRights).includes(code)) {
    return rights.includes(designationEditRights[code]);
  } else {
    // everything is editable by default
    return true;
  }
};
